export const useLivekitPeerId = (peerId: string) => ({
  externalPeerId: peerId,
});
